import TextField from './TextField';
import TextFieldStateless from './TextFieldStateless';
import PhoneNumberField from './PhoneNumberField';
import ZIPCodeField from './ZIPCodeField';
import EmailField from './EmailField';
import BirthdateField from './BirthdateField';

export default TextField;
export {
    TextField,
    TextFieldStateless,
    PhoneNumberField,
    ZIPCodeField,
    EmailField,
    BirthdateField
}